import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface Option {
  value: string;
  label: string;
  disabled?: boolean;
}

interface Props {
  name: string;
  label?: string;
  options: Option[];
  control: Control<any, any>;
  required?: boolean;
  disabled?: boolean;
  row?: boolean;
}

export default function RhfMultiCheckbox({
  control,
  label,
  name,
  options,
  required = false,
  disabled = false,
  row = false,
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({
        field: { name, onChange, ref, value },
        fieldState: { error },
      }) => {
        const selectedValues = (value as string[]) || [];

        const handleCheckboxChange = (
          optionValue: string,
          checked: boolean,
        ) => {
          if (checked) {
            // Add the value if it's not already in the array
            if (!selectedValues.includes(optionValue)) {
              onChange([...selectedValues, optionValue]);
            }
          } else {
            // Remove the value from the array
            onChange(
              selectedValues.filter((val: string) => val !== optionValue),
            );
          }
        };

        return (
          <FormGroup row={row}>
            {label && (
              <FormLabel
                component="legend"
                required={required}
                error={error ? true : false}
              >
                {label}
              </FormLabel>
            )}
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    name={name}
                    inputRef={ref}
                    checked={selectedValues.includes(option.value)}
                    onChange={(e) =>
                      handleCheckboxChange(option.value, e.target.checked)
                    }
                    disabled={disabled || option.disabled}
                    required={required}
                  />
                }
                label={option.label}
              />
            ))}
          </FormGroup>
        );
      }}
    />
  );
}
